import { extraccionSimple } from './dbhelper';
export const obtenerDestinos = () => {
    
    return extraccionSimple("destinos");
};